import { createSelector } from "@ngrx/store";

import { AppState } from '../app.reducer';

export const selectAuthState = (state: AppState) => state.auth;

export const selectAuthCodeData = createSelector(
    selectAuthState,
    (state) => state.tokenData
);
export const selectConfirmUserAccount = createSelector(
    selectAuthState,
    (state) => state.confirmUserAccount
);
export const selectRegistrationSuccess = createSelector(
    selectAuthState,
    (state) => state.registrationSuccess
);
export const selectResetted = createSelector(
    selectAuthState,
    (state) => state.resetted
);
export const selectLoginMfaCode = createSelector(
    selectAuthState,
    (state) => state.loginMfaCode
);